import { LocDef, LocDefs, LocMap } from '@cm/core/localization';
import { HubFeature } from '@ats/api/cm';

const pathStart = 'System Settings|Tagging|Tagging Items|Tagged Items|';
const sharedProperties: Pick<LocDef, 'shared' | 'htmlAllowed' | 'feature' | 'portal'> = {
	shared: false,
	htmlAllowed: false,
	feature: HubFeature.Tagging,
	portal: 'SP',
};

type LocNameStart = 'SPTaggedItems';
export type SPTaggedItemsLocNames =
	| `${LocNameStart}TitleSection`
	| `${LocNameStart}ButtonChangeTags`
	| `${LocNameStart}ButtonUntag`
	| `${LocNameStart}LabelFilterByTagName`
	| `${LocNameStart}LabelFilterByType`
	| `${LocNameStart}LabelTagName`
	| `${LocNameStart}LabelName`
	| `${LocNameStart}LabelExternalId`
	| `${LocNameStart}LabelType`;

export const spTaggedItemsLocs: LocDefs<SPTaggedItemsLocNames> = {
	SPTaggedItemsTitleSection: {
		defaultValue: 'Tagged Items',
		description: 'Tagged Items title.',
		displayPath: `${pathStart}Section Title`,
		displayType: 'Title',
		// legacyName: 'Tagging/SystemSettings.TaggingItems.TaggedItems.Title.TaggedItems',
		...sharedProperties,
	},
	SPTaggedItemsButtonChangeTags: {
		defaultValue: 'Change Selected Item Tags',
		description: 'Change Selected Item Tags button.',
		displayPath: `${pathStart}Change Selected Item Tags`,
		displayType: 'Button',
		// legacyName: 'Tagging/SystemSettings.TaggingItems.TaggedItems.Button.ChangeTags',
		...sharedProperties,
	},
	SPTaggedItemsButtonUntag: {
		defaultValue: 'Untag Selected Items',
		description: 'Untag Selected Items button.',
		displayPath: `${pathStart}Untag Selected Items`,
		displayType: 'Button',
		// legacyName: 'Tagging/SystemSettings.TaggingItems.TaggedItems.Button.UntagItems',
		...sharedProperties,
	},
	SPTaggedItemsLabelFilterByTagName: {
		defaultValue: 'Filter by Tag Name',
		description: 'Label for: Filter by Tag Name.',
		displayPath: `${pathStart}Filter by Tag Name`,
		displayType: 'Label',
		// legacyName: 'Tagging/SystemSettings.TaggingItems.TaggedItems.FieldLabel.FilterByTag',
		...sharedProperties,
	},
	SPTaggedItemsLabelFilterByType: {
		defaultValue: 'Filter by Type',
		description: 'Label for: Filter by Type.',
		displayPath: `${pathStart}Filter by Type`,
		displayType: 'Label',
		// legacyName: 'Tagging/SystemSettings.TaggingItems.TaggedItems.FieldLabel.FilterByType',
		...sharedProperties,
	},
	SPTaggedItemsLabelTagName: {
		defaultValue: 'Tag Name',
		description: 'Column heading for: Tag Name.',
		displayPath: `${pathStart}Tag Name`,
		displayType: 'Label',
		// legacyName: 'Tagging/SystemSettings.TaggingItems.TaggedItems.ColumnHeading.Tag',
		...sharedProperties,
	},
	SPTaggedItemsLabelName: {
		defaultValue: 'Name',
		description: 'Column heading for: Name.',
		displayPath: `${pathStart}Name`,
		displayType: 'Label',
		// legacyName: 'Tagging/SystemSettings.TaggingItems.TaggedItems.ColumnHeading.Name',
		...sharedProperties,
	},
	SPTaggedItemsLabelExternalId: {
		defaultValue: 'External ID',
		description: 'Column heading for: External ID.',
		displayPath: `${pathStart}External ID`,
		displayType: 'Label',
		// legacyName: 'Tagging/SystemSettings.TaggingItems.TaggedItems.ColumnHeading.ExternalId',
		...sharedProperties,
	},
	SPTaggedItemsLabelType: {
		defaultValue: 'Type',
		description: 'Column heading for: Type.',
		displayPath: `${pathStart}Type`,
		displayType: 'Label',
		// legacyName: 'Tagging/SystemSettings.TaggingItems.TaggedItems.ColumnHeading.Type',
		...sharedProperties,
	},
};

export type SPTaggedItemsLocType = LocMap<SPTaggedItemsLocNames>;
